import { html, ref, when, repeat } from '@microsoft/fast-element';
import { sync } from '@genesislcap/foundation-utils';
import type { PermitsTab } from './permits-government-approvals';

export const PermitsTabTemplate = html<PermitsTab>`
  <div class="form-control required">
    <label>Land Control Agreements (easements, leases, purchase options)</label>
    <zero-select
      ${ref('landControlAgreements')}
      :value=${sync((x) => x.landControlAgreementsValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Title Insurance</label>
    <zero-select
      ${ref('titleInsurance')}
      :value=${sync((x) => x.titleInsuranceValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Litigation Disclosure</label>
    <zero-select
      ${ref('litigationDisclosure')}
      :value=${sync((x) => x.litigationDisclosureValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Certified American Land Title Association Survey</label>
    <zero-select
      ${ref('landTitleAssociationSurvey')}
      :value=${sync((x) => x.landTitleAssociationSurveyValue)}
      class="input-control"
    >
        ${repeat(
          (x) => x.submissionStatusEnum,
          html`
            <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
          `
        )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label
      >Federal Eemergency Management Agency Standard Flood Hazard
      Determination</label
    >
    <zero-select
      ${ref('emergencyManagement')}
      :value=${sync((x) => x.emergencyManagementValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.submissionStatusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Phase I Environmental (ESA) Review</label>
    <zero-select
      ${ref('phaseIEnvironmentalReview')}
      :value=${sync((x) => x.phaseIEnvironmentalReviewValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Wetlands Delineation Review</label>
    <zero-select
      ${ref('wetlandsDelineationReview')}
      :value=${sync((x) => x.wetlandsDelineationReviewValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Threatened or Endangered Species Review</label>
    <zero-select
      ${ref('speciesReview')}
      :value=${sync((x) => x.speciesReviewValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Cultural Resources Study Review</label>
    <zero-select
      ${ref('culturalResourcesStudyReview')}
      :value=${sync((x) => x.culturalResourcesStudyReviewValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.statusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Primary State-level Permit</label>
    <zero-select
      ${ref('primaryStateLevelPermit')}
      :value=${sync((x) => x.primaryStateLevelPermitValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.submissionStatusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Primary County-level Permit</label>
    <zero-select
      ${ref('primaryCountyLevelPermit')}
      :value=${sync((x) => x.primaryCountyLevelPermitValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.submissionStatusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Primary Township-level Permit</label>
    <zero-select
      ${ref('primaryTownshipLevelPermit')}
      :value=${sync((x) => x.primaryTownshipLevelPermitValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.submissionStatusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
  <div class="form-control required">
    <label>Tax abatement Application</label>
    <zero-select
      ${ref('taxAbatementApplication')}
      :value=${sync((x) => x.taxAbatementApplicationValue)}
      class="input-control"
    >
    ${repeat(
      (x) => x.submissionStatusEnum,
      html`
        <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
      `
    )}
    </zero-select>
  </div>
  </div>
  <div class="form-control required">
    <label>DNH from FAA (wind only)</label>
    <zero-select
      ${ref('DnhFromFaa')}
      :value=${sync((x) => x.DnhFromFaaValue)}
      class="input-control"
    >
      ${repeat(
        (x) => x.submissionStatusEnum,
        html`
          <zero-option value="${(x) => x.ENUM_VALUE}">${(x) => x.READABLE_VALUE}</zero-option>
        `
      )}
    </zero-select>
  </div>
`;
